import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";

const API_BASE_URL = "https://warfc.com/api";

export default function HomeCover() {
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  // ================================
  // GET CURRENT COVER
  // ================================
  useEffect(() => {
    const fetchCover = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/home-cover`
        );

        const data = await response.json();

        if (data.success && data.imageUrl) {
          setImageUrl(data.imageUrl);
        }
      } catch (error) {
        console.error("Failed to load homepage cover:", error);
      }
    };

    fetchCover();
  }, []);

  // ================================
  // SELECT IMAGE
  // ================================
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setSelectedFile(file);
    setMessage("");

    const previewUrl = URL.createObjectURL(file);
    setPreview(previewUrl);
  };

  // ================================
  // UPLOAD
  // ================================
  const handleUpload = async () => {
    if (!selectedFile) {
      setMessage("Please select an image first.");
      return;
    }

    try {
      setUploading(true);
      setMessage("");

      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("image", selectedFile);

      const response = await fetch(
        `${API_BASE_URL}/admin/home-cover`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.error || "Upload failed"
        );
      }

      setImageUrl(data.imageUrl);
      setSelectedFile(null);
      setPreview(null);

      setMessage("✓ Homepage cover updated successfully.");

    } catch (error) {
      console.error("Homepage cover upload error:", error);

      setMessage(
        error.message || "Failed to upload image."
      );
    } finally {
      setUploading(false);
    }
  };

  const currentImage =
    preview ||
    (imageUrl
      ? `https://warfc.com${imageUrl}`
      : null);

  return (
    <AdminLayout>
      <div className="p-6 text-white max-w-4xl">

        <h1 className="text-3xl font-bold mb-2">
          Homepage Cover
        </h1>

        <p className="text-gray-400 mb-6">
          Change the main cover image displayed on the WAR FC homepage.
        </p>

        {/* CURRENT / PREVIEW */}
        <div className="bg-gray-900 border border-gray-700 rounded-xl p-5">

          <h2 className="text-lg font-bold mb-4">
            {preview ? "New Cover Preview" : "Current Cover"}
          </h2>

          {currentImage ? (
            <div className="rounded-xl overflow-hidden border border-gray-700 mb-5">
              <img
                src={currentImage}
                alt="Homepage Cover"
                className="w-full aspect-[16/7] object-cover"
              />
            </div>
          ) : (
            <div className="w-full aspect-[16/7] rounded-xl bg-gray-800 flex items-center justify-center text-gray-500 mb-5">
              No homepage cover uploaded
            </div>
          )}

          {/* FILE INPUT */}
          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2">
              Select new cover image
            </label>

            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="block w-full text-sm text-gray-300
                file:mr-4 file:py-2 file:px-4
                file:rounded-lg file:border-0
                file:bg-yellow-500 file:text-black
                file:font-semibold
                hover:file:bg-yellow-400
                cursor-pointer"
            />
          </div>

          {/* UPLOAD BUTTON */}
          <button
            onClick={handleUpload}
            disabled={!selectedFile || uploading}
            className="px-6 py-3 rounded-lg
              bg-yellow-500 text-black font-bold
              hover:bg-yellow-400
              disabled:opacity-40
              disabled:cursor-not-allowed
              transition"
          >
            {uploading
              ? "Uploading..."
              : "Upload Cover"}
          </button>

          {/* MESSAGE */}
          {message && (
            <p className="mt-4 text-sm text-gray-300">
              {message}
            </p>
          )}

        </div>
      </div>
    </AdminLayout>
  );
}